var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 15.0838C0.5 22.5413 5.91625 28.7425 13 30V19.1663H9.25V15H13V11.6663C13 7.91625 15.4163 5.83375 18.8337 5.83375C19.9163 5.83375 21.0837 6 22.1663 6.16625V10H20.25C18.4163 10 18 10.9163 18 12.0837V15H22L21.3337 19.1663H18V30C25.0837 28.7425 30.5 22.5425 30.5 15.0838C30.5 6.7875 23.75 0 15.5 0C7.25 0 0.5 6.7875 0.5 15.0838Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.edbc311c947de3ef99f4e02c905060c5.svg";
export { ForwardRef as ReactComponent };